import CMSHeader from './CMSHeader/'
import { Routes, Route } from 'react-router-dom'
import CMSAuth from './CMSAuth'
import './styles.scss'
import { useState } from 'react'

export default function CMS(props) {
  const [ signedIn, setSignedIn ] = useState(0)
  return (
    <div className='CMS'>
      <CMSHeader signedIn={signedIn} setSignedIn={setSignedIn} />
        <Routes>
          <Route path="/*" element={<CMSAuth signedIn={signedIn} setSignedIn={setSignedIn} />} />
        </Routes>
    </div>
  )
}
